export { OnReadyModule } from './on-ready.module';


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/shared/modules/on-ready/index.ts